<template>
  <div class="create_bt">
    <CreateBotForm />
  </div>
</template>

<script>
import CreateBotForm from "./CreateBots/CreateBotForm.vue";
export default {
  components: {
    CreateBotForm,
  },
};
</script>

<style scoped>
.create_bt {
  padding: 48px 48px 0 48px;
  overflow: auto;
  height: calc(100vh - 146px);

  @media screen and (max-width: 768px) {
    padding: 16px;
  }
}
</style>
